import React from "react";
import CategoriesNavSlider from "../layouts/sliders/CategoriesNavSlider";

const Categories = () => {
  return (
    <section className="categories section">
      <div className="container">
        <div className="content">
          <CategoriesNavSlider />
        </div>
      </div>
    </section>
  );
};

export default Categories;
